import styled from "styled-components";
import { theme } from "../theme";

export const StyledMeetingsList = styled.div`
	display: flex;
	flex-wrap: wrap;
	column-gap: 2rem;
	row-gap: 2rem;
`;

export const StyledMeetingCard = styled.div`
	width: 30rem;
	margin-bottom: 0.2rem;
	padding: 1.3rem 1.3rem 4rem;
	box-shadow: 0 2px 3px rgba(0, 0, 0, 0.15);
	background-color: white;

	position: relative;

	& h4 {
		font-size: 1.8rem;
		font-weight: 700;
	}

	& .main-info {
		padding-bottom: 0.8rem;

		border-bottom: 1px solid #e5e9ec;
	}

	& .unit {
		padding: 0.8rem 0;

		border-bottom: 1px solid #e5e9ec;

		display: flex;
		align-items: center;
		justify-content: flex-start;
		flex-wrap: wrap;
		row-gap: 1rem;

		& > *:first-child {
			width: 100%;
			min-height: 3.4rem;
			padding-left: 5rem;
			position: relative;
		}

		& > *:not(:first-child) {
			width: 50%;
		}

		& span {
			margin-bottom: 0;

			display: block;

			color: #4d5660;
			font-size: 0.8rem;
			font-weight: 500;
			font-family: ${theme.font.secondary};
			text-transform: uppercase;
		}

		& .icon {
			width: 3.4rem;
			height: 3.4rem;

			display: flex;
			align-items: center;
			justify-content: center;

			position: absolute;
			top: 50%;
			left: 0.5rem;

			background-color: ${(props) => (props.unitColor ? props.unitColor : "cyan")};
			border-radius: 100rem;

			transform: translateY(-50%);

			& > span {
				height: 1.7rem;
				width: min-content;

				color: #ffffff;
				text-transform: uppercase;
				font-family: ${theme.font.secondary};
				font-size: 1.5rem;
				font-weight: 500;

				display: block;
			}
		}
	}

	& .agenda {
		padding: 0.8rem 0;

		border-bottom: 1px solid #e5e9ec;

		display: flex;
		column-gap: 1rem;
	}

	& > a {
		margin: 0 auto;
		padding: 1.6rem 0 0.4rem;

		display: block;

		position: absolute;
		bottom: 0.8rem;
		left: 50%;

		transform: translateX(-50%);

		font-size: 1.2rem;
		font-weight: 500;
		font-family: ${theme.font.secondary};
		text-transform: uppercase;
	}
`;
